const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.75)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 99999,
  pointerEvents: "all",
};

const modalStyle = {
  backgroundColor: "#fff",
  padding: "3rem 2.5rem",
  borderRadius: "12px",
  textAlign: "center",
  maxWidth: "480px",
  width: "90%",
  boxShadow: "0 20px 60px rgba(0, 0, 0, 0.4)",
};

export default function MaintenanceModal() {
  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={{ fontSize: "48px", marginBottom: "1rem" }}>🔧</div>
        <h1 style={{ fontSize: "24px", fontWeight: 700, color: "#222", marginBottom: "1rem" }}>
          Sitio en mantenimiento
        </h1>
        <p style={{ fontSize: "15px", color: "#666", lineHeight: 1.7, margin: 0 }}>
          El sitio web está en modo de mantenimiento.<br />
          Por favor, intente ingresar nuevamente en unos minutos.
        </p>
      </div>
    </div>
  );
}
